import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

//css

import "./components/collection.css";
import "./components/navbar.css";
import "./components/footer.css";
import "./components/home.css";
import "./components/aboutus.css";
import "./components/contact.css";
import "./components/customjewelryform.css";

import Home from "./components/Home.jsx";

import Footer from "../src/components/Footer.jsx";
import Contact from "./components/Contact.jsx";

import Collection from "./components/Collection.jsx";
import Stones from "./components/Stones.jsx";
import CustomJewelryForm from "./components/CustomJewelryForm.jsx";
import AboutUs from "./components/AboutUs.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/collection" element={<Collection />} />
        <Route path="/stones" element={<Stones />} />
        <Route path="/CustomJewelryForm" element={<CustomJewelryForm />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
